{
  "locale": "Deutsch",
  "sidebar": {
    "title": "Anfrage zum Datenaustausch",
    "issuanceTitle": "Anfrage zum Hinzufügen von Daten",
    "authenticationTitle": "Authentifizierungsanfrage",
    "description": "{clientName} fragt verifizierte personenbezogene Daten aus Ihrer Identitäts-App an. Überprüfen Sie die Details unten und genehmigen oder lehnen Sie diese Anfrage in Ihrer Identitäts-App ab.",
    "issuanceDescription": "{clientName} fügt verifizierte Daten zu Ihrer Identitäts-App hinzu. Überprüfen Sie die Details unten und bestätigen Sie in Ihrer Identitäts-App, ob Sie diese akzeptieren möchten.",
    "authenticationDescription": "{clientName} möchte sich mit Ihrer Identitäts-App authentifizieren.",
    "descriptionFallback": "Ein Dienst fragt verifizierte personenbezogene Daten aus Ihrer Identitäts-App an. Überprüfen Sie die Details unten und genehmigen oder lehnen Sie diese Anfrage in Ihrer Identitäts-App ab.",
    "issuanceDescriptionFallback": "Ein Dienst fügt verifizierte Daten zu Ihrer Identitäts-App hinzu. Überprüfen Sie die Details unten und bestätigen Sie in Ihrer Identitäts-App, ob Sie diese akzeptieren möchten.",
    "authenticationDescriptionFallback": "Ein Dienst möchte sich mit Ihrer Identitäts-App authentifizieren.",
    "stepsTitle": "Schritte zum Abschließen",
    "stepShareData": "Daten mit {clientName} teilen",
    "stepAuthenticate": "Authentifizieren für {clientName}",
    "stepReceiveData": "Daten von {clientName} empfangen",
    "stepGeneric": "Erforderliche Schritte abschließen",
    "defaultClientName": "dem Dienst",
    "requestedDataTitle": "Die folgenden Daten werden angefragt",
    "issuedDataTitle": "Die folgenden Daten werden ausgestellt",
    "reviewNotice": "Sie überprüfen und genehmigen die genauen Daten in Ihrer Identitäts-App, bevor etwas geteilt wird.",
    "issuanceReviewNotice": "Sie überprüfen und genehmigen die genauen Daten in Ihrer Identitäts-App, bevor etwas hinzugefügt wird.",
    "indeterminateHint": "Die angeforderten Daten werden sichtbar, nachdem Sie eine Identitäts-App ausgewählt haben",
    "showAll": "Alle anzeigen",
    "purposeStatementTitle": "Warum Ihre Daten benötigt werden",
    "retentionPolicyTitle": "Wie Ihre Daten behandelt werden"
  },
  "footer": {
    "powered": "Bereitgestellt von",
    "privacyPolicy": "Datenschutzerklärung"
  },
  "topBar": {
    "openMenu": "Menü öffnen",
    "closeMenu": "Menü schließen",
    "language": "Sprache"
  },
  "app": {
    "loadingTitle": "Wird geladen"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Suchen",
    "noResults": "Keine Ergebnisse"
  },
  "init": {
    "title": "Anfrage wird verarbeitet",
    "hint": "Die Sitzung wird vorbereitet"
  },
  "pairing": {
    "title": "Nächster Schritt wird vorbereitet",
    "hint": "Die Sitzung wird vorbereitet",
    "codeLabel": "Überprüfen Sie den folgenden Code in Ihrer Identitäts-App",
    "confirm": "Kopplung bestätigen"
  },
  "waitingForPresentation": {
    "title": "Fahren Sie in Ihrer Identitäts-App fort",
    "hint": "Bitte überprüfen und genehmigen Sie die Anfrage in Ihrer Identitäts-App"
  },
  "agentStart": {
    "title": "Weiter in {appName}",
    "subtitle": "Um Ihre Daten sicher zu teilen, scannen Sie diesen QR-Code mit {appName}, um die Anfrage zu überprüfen und zu genehmigen.",
    "issuanceSubtitle": "Um die Daten sicher zu empfangen, scannen Sie diesen QR-Code mit {appName}, um die Anfrage zu überprüfen und zu genehmigen.",
    "step1": "{appName} öffnen",
    "step2": "Auf das Scanner-Symbol klicken",
    "step3": "Diesen QR-Code scannen",
    "changeApp": "Identitäts-App wechseln",
    "installInstructions": "Installationsanleitung",
    "cancel": "Abbrechen",
    "needHelp": "Brauchen Sie Hilfe?",
    "redirectSubtitle": "Klicken Sie auf die Schaltfläche unten, um {appName} zu öffnen und die Anfrage zu genehmigen.",
    "issuanceRedirectSubtitle": "Klicken Sie auf die Schaltfläche unten, um {appName} zu öffnen und die Anfrage zu genehmigen.",
    "redirectButton": "Weiter",
    "mobileSubtitle": "Um Ihre Daten sicher zu teilen, fahren Sie in {appName} fort, um die Anfrage zu überprüfen und zu genehmigen.",
    "issuanceMobileSubtitle": "Um die Daten sicher zu empfangen, fahren Sie in {appName} fort, um die Anfrage zu überprüfen und zu genehmigen.",
    "openApp": "{appName} öffnen",
    "showQr": "QR-Code anzeigen"
  },
  "done": {
    "disclosure": {
      "title": "Daten wurden erfolgreich geteilt",
      "subtitle": "Die Seite wird in wenigen Sekunden automatisch geschlossen.",
      "subtitleCloseTab": "Daten erfolgreich geteilt. Sie können diese Seite schließen."
    },
    "issuance": {
      "title": "Daten erfolgreich empfangen",
      "subtitle": "Die Seite wird in wenigen Sekunden automatisch geschlossen.",
      "subtitleCloseTab": "Daten erfolgreich empfangen. Sie können diese Seite schließen."
    },
    "redirecting": "Weiterleitung...",
    "completeRedirect": "Abschließen und weiterleiten",
    "redirectFailed": "Die automatische Weiterleitung hat nicht funktioniert. Tippen Sie unten, um fortzufahren."
  },
  "abort": {
    "cancelled": {
      "title": "Prozess gestoppt",
      "subtitle": "Sie haben den Prozess gestoppt. Sie können jederzeit neu starten."
    },
    "serverError": {
      "title": "Etwas ist schiefgelaufen",
      "subtitle": "Wir konnten den Prozess aufgrund eines technischen Problems nicht abschließen."
    },
    "expired": {
      "title": "Sitzung abgelaufen",
      "subtitle": "Diese Sitzung wurde nach einer Zeit der Inaktivität beendet. Schließen Sie diese Seite und starten Sie den Prozess neu, um fortzufahren."
    },
    "connectionLost": {
      "title": "Verbindung verloren",
      "subtitle": "Ihre Internetverbindung wurde unterbrochen. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut."
    },
    "temporarilyUnavailable": {
      "title": "Dienst vorübergehend nicht verfügbar",
      "subtitle": "Der Dienst wird derzeit gewartet. Bitte versuchen Sie es später erneut."
    },
    "appError": {
      "title": "Identitäts-App nicht verfügbar",
      "subtitle": "Wir konnten keine Verbindung zur ausgewählten Identitäts-App herstellen. Die App ist möglicherweise vorübergehend nicht verfügbar. Sie können eine andere Identitäts-App ausprobieren oder es später erneut versuchen."
    },
    "selectDifferentApp": "Andere Identitäts-App auswählen",
    "confirmTitle": "Prozess stoppen?",
    "confirmMessage": "Sind Sie sicher, dass Sie stoppen möchten? Sie können jederzeit neu starten, wenn Sie später fortfahren möchten.",
    "confirmStop": "Prozess stoppen",
    "goBack": "Zurück",
    "leave": "Verlassen",
    "restart": "Neu starten",
    "retry": "Erneut versuchen",
    "contactOrganisation": {
      "subtitle": "Wir konnten den Prozess nicht starten. Bitte wenden Sie sich für Hilfe an die Organisation."
    }
  },
  "appPicker": {
    "title": "Unterstützte Identitäts-Apps",
    "subtitle": "Die folgenden Identitäts-Apps können verwendet werden, um die Anfrage zu überprüfen und zu genehmigen",
    "searchPlaceholder": "Suchen...",
    "sectionLastUsed": "Zuletzt verwendet",
    "sectionRecommended": "Empfohlen",
    "sectionAZ": "A-Z",
    "noResults": "Keine Apps entsprechen Ihrer Suche",
    "filterTitle": "Nach Land filtern",
    "filterClear": "Alle löschen",
    "filterDone": "Fertig"
  },
  "faq": {
    "helpQuestion": "Frage",
    "moreHelp": "Weitere Hilfe",
    "close": "Schließen",
    "whatAreWallets": {
      "title": "Was sind Identitäts-Apps?",
      "body": "Mit einer Identitäts-App haben Sie die Kontrolle über Ihre eigenen Daten — Sie allein entscheiden, welche Daten Sie mit wem und wann teilen. Ihre Daten werden von einem verifizierten Aussteller abgerufen und zusammen mit einer digitalen Signatur in der App gespeichert, die deren Korrektheit garantiert.\n\nWenn Sie Ihre Daten mit einem Dritten teilen, wird die digitale Signatur mitgesendet, damit die empfangende Partei die Echtheit überprüfen kann. Ihre Daten werden normalerweise nur auf Ihrem eigenen Telefon gespeichert und können bei Bedarf leicht erneut abgerufen werden.\n\nSeien Sie sich immer bewusst, dass es Ihre Verantwortung ist, sorgfältig auszuwählen, mit wem Sie Ihre Daten teilen."
    },
    "whyNotSupported": {
      "title": "Warum wird meine Identitäts-App nicht unterstützt?",
      "body": "Es kann vorkommen, dass Ihre spezifische Identitäts-App nicht verfügbar ist, da die empfangende Partei oder unsere Plattform sie derzeit nicht unterstützt. Wir arbeiten ständig daran, unser Angebot an unterstützten Apps zu erweitern.\n\nWenn Ihre App nicht aufgeführt ist, können Sie immer eine der anderen unterstützten Identitäts-Apps installieren und verwenden."
    },
    "howDataProtected": {
      "title": "Wie werden meine Daten geschützt?",
      "body": "Identitäts-Apps stellen sicher, dass Sie immer die Kontrolle darüber behalten, mit wem Sie Ihre Daten wann teilen. Diese Apps bieten Ihnen normalerweise einen Überblick darüber, welche Daten Sie mit wem und wann geteilt haben.\n\nVer.iD sendet Ihre Daten direkt an die empfangende Partei und prüft nur, ob sie korrekt übermittelt wurden.\n\nSeien Sie sich immer bewusst, dass es Ihre Verantwortung ist, sorgfältig auszuwählen, mit wem Sie Ihre Daten teilen.",
      "link": "Mehr über Sicherheit und Datenschutz"
    },
    "howObtainData": {
      "title": "Wie kann ich Daten in meine App einfügen?",
      "body": "Jede Identitäts-App hat eine eigene Methode zur Datensammlung. Die meisten Apps haben eine Schaltfläche, mit der Sie Daten hinzufügen können. In einigen Fällen sind damit Kosten verbunden.\n\nFollgen Sie den Anweisungen in der App, um Ihre Daten sicher zu sammeln. Möglicherweise werden Sie auf Regierungswebsites weitergeleitet oder müssen Dokumente wie Pässe oder Führerscheine scannen.\n\nWenn Sie keine direkte Möglichkeit sehen, die richtigen Daten einzufügen, überprüfen Sie die Dokumentationsseite oder wenden Sie sich an den App-Anbieter. Sie können auch eine andere Identitäts-App ausprobieren."
    },
    "whyRedirection": {
      "title": "Warum werde ich weitergeleitet?",
      "body": "Einige Identitäts-Apps erfordern eine Weiterleitung auf ihre eigene Website, damit Ihre Daten gemäß deren Standards geteilt werden und die beste Benutzererfahrung in einer vertrauten Umgebung gewährleistet wird.\n\nNach erfolgreichem Teilen werden Sie automatisch zu Ver.iD zurückgeleitet, wo Ihre Daten auf Ihre Bestätigung warten, bevor sie an die empfangende Partei gesendet werden. Ein digitaler Beleg ist normalerweise in Ihrer Identitäts-App zu finden.\n\nWenn der Prozess fehlschlägt oder abgebrochen wird, werden Sie ebenfalls zurückgeleitet und können es erneut versuchen."
    }
  },
  "mobileFlowStart": {
    "startVerification": "Weiter"
  },
  "requestedDataModal": {
    "title": "Angeforderte Daten",
    "subtitle": "Sie überprüfen und genehmigen diese Anfrage in Ihrer Identitäts-App.",
    "attribute": "Attribut",
    "description": "Beschreibung",
    "issuedBy": "Daten ausgestellt von",
    "close": "Schließen"
  },
  "demo": {
    "title": "Demo-Umgebung",
    "description": "Sie verwenden eine interaktive Demo von Ver.iD. Diese Umgebung dient ausschließlich zu Demonstrationszwecken."
  },
  "installInstructions": {
    "title": "{appName} installieren",
    "subtitle": "Besuchen Sie den App Store oder Play Store auf Ihrem Telefon, um {appName} Identitäts-App zu installieren. Scannen Sie den Code, um direkt die Store-Seite zu öffnen und die App zu installieren.",
    "close": "Schließen",
    "unavailableTitle": "Anleitung nicht verfügbar",
    "unavailableBody": "Leider haben wir derzeit keine Installationsanleitung für diese App verfügbar. Versuchen Sie, manuell im App Store nach der App zu suchen, um fortzufahren."
  },
  "embedded": {
    "loading": "Identitäts-Apps werden geladen",
    "moreApps": "{count} weitere Apps",
    "moreAppsOne": "1 weitere App",
    "useAnotherApp": "Andere App verwenden",
    "cancel": "Abbrechen",
    "back": "Zurück",
    "tryAgain": "Erneut versuchen",
    "qr": {
      "caption": "Scannen Sie mit {bold}, um Ihre Daten zu teilen.",
      "captionIssuance": "Scannen Sie mit {bold}, um Ihre Daten hinzuzufügen.",
      "label": "QR-Code zum Scannen mit {app}",
      "noApp": "Keine {app}-App?",
      "whatShared": "Was wird geteilt?",
      "whatAdded": "Was wird hinzugefügt?",
      "expired": "Dieser QR-Code ist abgelaufen.",
      "refresh": "QR erneuern"
    },
    "waiting": {
      "title": "Weiter in {app}",
      "sub": "Bestätigen Sie die Anfrage auf Ihrem Telefon.",
      "subIssuance": "Akzeptieren Sie die Daten auf Ihrem Telefon.",
      "help": "Sehen Sie die Anfrage nicht?"
    },
    "done": {
      "title": "Mit {app} geteilt",
      "sub": "Sie können mit Ihrem Antrag fortfahren.",
      "titleIssuance": "Zu {app} hinzugefügt",
      "subIssuance": "Ihre Daten sind jetzt in der App."
    },
    "error": {
      "title": "Teilen wurde nicht abgeschlossen",
      "sub": "Es wurde nichts geteilt.",
      "titleIssuance": "Ihre Daten wurden nicht hinzugefügt",
      "subIssuance": "Zu {app} wurde nichts hinzugefügt.",
      "help": "Warum wurde es nicht abgeschlossen?"
    },
    "unsupported": {
      "title": "{app} kann hier noch nicht verwendet werden",
      "sub": "Verwenden Sie eine andere App, um fortzufahren."
    },
    "install": {
      "caption": "Installieren Sie zuerst {bold}: Scannen Sie mit der Kamera Ihres Telefons.",
      "label": "QR-Code zum Herunterladen von {app} aus Ihrem App Store",
      "installed": "Ich habe sie installiert"
    },
    "missing": {
      "title": "Noch keine Installationsschritte",
      "sub": "Installieren Sie {app} so, wie der Anbieter es beschreibt, und kommen Sie dann zurück."
    },
    "notListed": {
      "title": "Sehen Sie Ihre App nicht?",
      "sub": "{org} akzeptiert nur diese Apps. Wählen Sie eine aus, um zu sehen, wie Sie sie installieren.",
      "subIssuance": "{org} kann Daten nur zu diesen Apps hinzufügen. Wählen Sie eine aus, um zu sehen, wie Sie sie installieren.",
      "back": "Zurück zu den Apps"
    },
    "request": {
      "title": "Sehen Sie die Anfrage nicht?",
      "sub": "Lassen Sie {app} geöffnet, es kann einige Sekunden dauern. Immer noch nichts? Scannen Sie den QR-Code erneut.",
      "keepWaiting": "Weiter warten",
      "scanAgain": "Erneut scannen"
    },
    "why": {
      "title": "Warum wurde es nicht abgeschlossen?",
      "sub": "Es wurde in {app} abgebrochen oder hat zu lange gedauert. Es wurde nichts geteilt.",
      "subIssuance": "Es wurde in {app} abgebrochen oder hat zu lange gedauert. Es wurde nichts hinzugefügt."
    },
    "details": {
      "label": "Was wird geteilt",
      "caption": "Angefragt von {bold}. Sie bestätigen es zuerst in Ihrer App.",
      "back": "Zurück zum QR-Code",
      "labelIssuance": "Was wird hinzugefügt",
      "captionIssuance": "Ausgestellt von {bold}. Sie akzeptieren es zuerst in Ihrer App.",
      "privacy": "Datenschutzerklärung",
      "security": "Wie werden meine Daten geschützt?"
    },
    "timeout": {
      "title": "Diese Anfrage ist abgelaufen",
      "sub": "Anfragen bleiben einige Minuten offen. Versuchen Sie es erneut, um eine neue zu erhalten."
    },
    "launch": {
      "title": "Mit {app} teilen",
      "sub": "Tippen Sie auf {app} öffnen, um die Anfrage anzusehen und zu bestätigen.",
      "titleIssuance": "Zu {app} hinzufügen",
      "subIssuance": "Tippen Sie auf {app} öffnen, um die Daten zu akzeptieren.",
      "open": "{app} öffnen"
    },
    "opening": {
      "sub": "Bestätigen Sie die Anfrage in der App.",
      "subIssuance": "Akzeptieren Sie die Daten in der App.",
      "help": "{app} hat sich nicht geöffnet?"
    },
    "notOpened": {
      "title": "{app} hat sich nicht geöffnet?",
      "sub": "{app} ist auf diesem Telefon möglicherweise nicht installiert. Installieren Sie die App, um fortzufahren.",
      "install": "{app} installieren"
    },
    "phoneInstall": {
      "title": "{app} nicht auf diesem Telefon?",
      "sub": "Laden Sie sie aus Ihrem App Store oder scannen Sie mit einem anderen Gerät.",
      "get": "{app} herunterladen",
      "scanOther": "Mit einem anderen Gerät scannen"
    },
    "phoneQr": {
      "openHere": "{app} auf diesem Telefon öffnen"
    },
    "drawer": {
      "close": "Schließen",
      "label": "Teilen Sie Ihre Daten mit einer Identitäts-App",
      "labelIssuance": "Fügen Sie Ihre Daten zu einer Identitäts-App hinzu"
    }
  }
}
